import { render, staticRenderFns } from "./RespondInfo.vue?vue&type=template&id=54baad07"
import script from "./RespondInfo.vue?vue&type=script&lang=ts"
export * from "./RespondInfo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports